import { RefObject, useContext, useEffect } from "react";
import { SectionContext } from "../context/SectionContext";

export const useSection = (ref: RefObject<HTMLElement | null>, section: string) => {
    const context = useContext(SectionContext);

    useEffect(() => {
        if (!ref.current) return;
        
        const projetsElem = ref.current as HTMLElement;
        
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0]?.isIntersecting) {
                    context.setActiveSection(section);
                }
            },
            {
                threshold: section === 'projets' ? 0 : 0.3,
                rootMargin: section === 'projets' ? '0px' : '-20% 0px -40% 0px'
            }
        );

        observer.observe(projetsElem);
        return () => observer.disconnect();
    }, [ref, section, context.setActiveSection, context]);
};
